scrollToInvalid = function scrollToInvalid(form) {
    const invalidInputs = Array.from(form.querySelectorAll('.error'));
    if(invalidInputs.length) {
        invalidInputs.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);
        invalidInputs[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
}